import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

import { useLanguage } from '../shared/LanguageContext'
import { displayDate } from './taFormat'
import { taCopy } from './taCopy'
import { SectionUnavailable } from './TaShell'

function SessionRow({ row, language, copy }) {
  return (
    <article className="ta-v2-schedule-row">
      <time dateTime={row.session_date}>
        <strong>{displayDate(row.session_date, language, { weekday: true })}</strong>
        <span>{row.time_display || '—'}</span>
      </time>
      <div>
        <h3>{row.class_name}</h3>
        <p>{copy('session')} {row.session_number}{row.location ? ` · ${row.location}` : ''}</p>
      </div>
    </article>
  )
}

export default function TaScheduleView({ home }) {
  const { language } = useLanguage()
  const copy = taCopy(language)
  const [showHistory, setShowHistory] = useState(false)
  const [showAllUpcoming, setShowAllUpcoming] = useState(false)
  if (home.schedule?.status !== 'ready') {
    return <div className="ta-v2-view"><SectionUnavailable /></div>
  }
  const schedule = home.schedule.data
  const upcoming = showAllUpcoming
    ? schedule.upcoming_sessions
    : schedule.upcoming_sessions.slice(0, 3)
  return (
    <div className="ta-v2-view">
      <section className="ta-v2-section ta-v2-section-first">
        <div className="ta-v2-section-heading">
          <h2>{copy('futureClasses')}</h2>
          <span>{schedule.upcoming_sessions.length}</span>
        </div>
        {schedule.upcoming_sessions.length ? (
          <div className="ta-v2-schedule-list">
            {upcoming.map((row) => (
              <SessionRow key={row.id} row={row} language={language} copy={copy} />
            ))}
          </div>
        ) : <p className="ta-v2-empty">{copy('noUpcoming')}</p>}
        {schedule.upcoming_sessions.length > 3 && (
          <button
            type="button"
            className="ta-v2-upcoming-toggle"
            aria-expanded={showAllUpcoming}
            onClick={() => setShowAllUpcoming((value) => !value)}
          >
            <span>{showAllUpcoming ? copy('showLess') : copy('showAll')}</span>
            <ChevronDown aria-hidden="true" size={16} className={showAllUpcoming ? 'is-open' : ''} />
          </button>
        )}
      </section>

      {schedule.past_sessions.length > 0 && (
        <section className="ta-v2-section">
          <button
            type="button"
            className="ta-v2-history-toggle"
            aria-expanded={showHistory}
            onClick={() => setShowHistory((value) => !value)}
          >
            <span>{showHistory ? copy('hideHistory') : copy('showHistory')}</span>
            <ChevronDown aria-hidden="true" size={19} className={showHistory ? 'is-open' : ''} />
          </button>
          {showHistory && (
            <div className="ta-v2-schedule-list ta-v2-past-list">
              {schedule.past_sessions.map((row) => (
                <SessionRow key={row.id} row={row} language={language} copy={copy} />
              ))}
            </div>
          )}
        </section>
      )}
    </div>
  )
}
